import { getHorizontalStep, updateHorizontalNavState } from "./scroller-utils";

const initHomepageBlogsContainer = (track) => {
  if (!track || track.dataset.homepageBlogsInitialized === "true") return;

  const section = track.closest(".homepage-blogs");
  const prevButton = section ? section.querySelector("[data-homepage-blogs-prev]") : null;
  const nextButton = section ? section.querySelector("[data-homepage-blogs-next]") : null;
  const cards = Array.from(track.querySelectorAll("article"));

  if (!cards.length) return;

  track.dataset.homepageBlogsInitialized = "true";

  let resizeTimer = null;

  const getStep = () => getHorizontalStep(track, cards[0]);

  const updateNavState = () => updateHorizontalNavState(track, prevButton, nextButton);

  const scrollByStep = (direction) => {
    track.scrollBy({
      left: getStep() * direction,
      behavior: "smooth",
    });
  };

  const handleResize = () => {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(() => {
      updateNavState();
    }, 120);
  };

  if (prevButton && nextButton) {
    prevButton.addEventListener("click", () => scrollByStep(-1));
    nextButton.addEventListener("click", () => scrollByStep(1));
  }

  track.addEventListener("scroll", updateNavState, { passive: true });
  window.addEventListener("resize", handleResize);

  updateNavState();
  window.setTimeout(updateNavState, 0);
};

const initHomepageBlogs = (root = document) => {
  if (!root) return;

  if (root.matches && root.matches("[data-homepage-blogs-track]")) {
    initHomepageBlogsContainer(root);
  }

  if (root.querySelectorAll) {
    root.querySelectorAll("[data-homepage-blogs-track]").forEach(initHomepageBlogsContainer);
  }
};

export { initHomepageBlogs };
